import axios from "axios";
import {API_ROOT, translate} from "../app/utils";
import store from "../store";
import {msgCommentBar} from "./msgBarActions";
import {findContacts} from "./contactActions";

export function findComments(contactId, pageSize = 50, pageNumber = 1, sortBy = "desc") {
    return function (dispatch, getState) {

        let ownerId = '';
        let groupId = '';
        const myObj = getState().contactReducer.contactCardDetails
        if(Object.keys(myObj).length>1){
            ownerId = store.getState().contactReducer.contactCardDetails.ownerId;
            groupId = store.getState().contactReducer.contactCardDetails.groupId;
        } else {

            if(!getState().contactReducer.contactSearchResult.contacts.length){

                if (Object.keys(getState().profileReducer.setGmailAddOnData).length === 0) {

                    /*
                    * GSC App
                    * */

                    if(getState().contactsGroupItemReducer.getSelectedContactsGroup) {
                      ownerId = getState().contactsGroupItemReducer.getSelectedContactsGroup.ownerId;
                    }

                } else {

                    /*
                    * Gmail Add-On
                    * */

                    ownerId = getState().profileReducer.setGmailAddOnData.userId;
                }

                if(getState().contactsGroupItemReducer.getSelectedContactsGroup) {
                  groupId = getState().contactsGroupItemReducer.getSelectedContactsGroup.id
                }

            }
        }

        axios.get(API_ROOT + '/api/contact/' + contactId + '/comment/?pageSize=' + pageSize + '&groupId=' + groupId  + '&ownerId=' + ownerId  + '&page=' + pageNumber + '&sort=' + sortBy, {withCredentials: true}).then( response => {
            dispatch({
                type: "FIND_COMMENTS",
                payload: response.data
            });
        });
    }
}

export function findNextComments(contactId, pageSize = 50, pageNumber = 1, sortBy = "desc") {
	return function (dispatch, getState) {

		let ownerId = getState().contactsGroupItemReducer.getSelectedContactsGroup.ownerId;
		let groupId = getState().contactsGroupItemReducer.getSelectedContactsGroup.id;

		axios.get(API_ROOT + '/api/contact/' + contactId + '/comment/?pageSize=' + pageSize + '&groupId=' + groupId  + '&ownerId=' + ownerId  + '&page=' + pageNumber + '&sort=' + sortBy, {withCredentials: true}).then( response => {
			dispatch({
				type: "FIND_NEXT_COMMENTS",
				payload: response.data
			});
		});
	}
}

export function checkSearchResultValue(labelId) {
	let ownerId = '';


    const myObj = store.getState().contactReducer.contactCardDetails
    if(Object.keys(myObj).length>1){
        /*
        * Direct contactcard
        **/
        ownerId = store.getState().contactReducer.contactCardDetails.ownerId;
        labelId = store.getState().contactReducer.contactCardDetails.groupId;
    } else if (!store.getState().contactReducer.contactSearchResult.contacts.length) {
		if (Object.keys(store.getState().profileReducer.setGmailAddOnData).length === 0) {
			/*
            * GSC App
            * */
			ownerId = store.getState().contactsGroupItemReducer.getSelectedContactsGroup.ownerId;
		} else {
			/*
			* Gmail Add-On
			* */
			ownerId = store.getState().profileReducer.setGmailAddOnData.userId;
        }
	} else {
		ownerId = '';
		labelId = '';
	}
	return [ownerId, labelId];
}

export function addComment(contactId, labelIdArg, msgObj) {
    return function (dispatch, getState) {

        const [ownerId, labelId] = checkSearchResultValue(labelIdArg);

        axios.post(API_ROOT + '/api/contact/' + contactId + '/comment/?groupId=' + labelId + '&ownerId=' + ownerId, msgObj || {}, {withCredentials: true}).then( () => {

            dispatch(msgCommentBar(['success', translate("textAddedComment")]));

	        if (Object.keys(getState().profileReducer.setGmailAddOnData).length === 0) {
		        /*
                * GSC App
                * */
		        dispatch(findComments(contactId, 3));
	        } else {
	            /*
                * Gmail Add-On
                * */
		        dispatch(findComments(contactId, 50));
            }


            if(document.getElementById("writeNewComment")){
                document.getElementById("writeNewComment").value = "";
            }

            /*
            * Refresh contacts list
            **/

            let selectedLabelId;

            if(getState().contactsGroupItemReducer.getSelectedContactsGroup.type === "system"){
	            selectedLabelId = 6;
            } else {
	            selectedLabelId = getState().contactsGroupItemReducer.getSelectedContactsGroup.id;
            }

            dispatch(findContacts(
	            selectedLabelId,
                getState().contactReducer.contactsPageSize,
                getState().contactReducer.contactsLetter
            ));

            /*
            * Empty comment to add
            **/

            dispatch(commentContentToAdd(""));

        }).catch((e) => {
            if(e.response.data.includes('readOnly')){
                dispatch(msgCommentBar(['error', translate('textCommentError')]));
            } else if (e.response.data === "Comment's length should be between 1 and 1000") {
                dispatch(msgCommentBar(['error', translate('textEmptyComment')]));
            } else {
                dispatch(msgCommentBar(['error', translate('textErrorAddComment')]));
            }
        }).finally(() => {
            dispatch(isLoadingCommentToAdd(false))
        });
    }
}

export function updateComment(contactId, commentId, labelIdArg, msgObj) {
    return function (dispatch, getState) {

        const [ownerId, labelId] = checkSearchResultValue(labelIdArg);

        axios.put(API_ROOT + '/api/contact/' + contactId + '/comment/' + commentId + '?groupId=' + labelId + '&ownerId=' + ownerId,msgObj || {}, {withCredentials: true}).then( () => {
            dispatch(msgCommentBar(['success', translate('textCommentSuccessfulUpdate')]));

	        if (Object.keys(getState().profileReducer.setGmailAddOnData).length === 0) {
		        /*
                * GSC App
                * */
		        dispatch(findComments(contactId, 3));
	        } else {
		        /*
				* Gmail Add-On
				* */
		        dispatch(findComments(contactId, 50));
	        }

            dispatch(editingComment(null));
        }).catch((e) => {
            if(e.response.data.includes('readOnly')){
                dispatch(msgCommentBar(['error', translate('textCommentError')]));
            } else if (e.response.data === "Comment's length should be between 1 and 1000") {
                dispatch(msgCommentBar(['error', translate('textEmptyComment')]));
            } else {
                dispatch(msgCommentBar(['error', translate('textErrorAddComment')]));
            }
        }).finally(() => {
            dispatch(isLoadingCommentToEdit(false))
        });
    }
}

export function editingComment(string) {
    return function (dispatch) {
        dispatch({
            type: 'EDITING_COMMENT',
            payload: string
        })
    }
}

export function deleteComment(contactId, commentId, labelIdArg) {
    return function (dispatch, getState) {

        const [ownerId, labelId] = checkSearchResultValue(labelIdArg);

        axios.delete(API_ROOT + '/api/contact/' + contactId + '/comment/' + commentId + '?groupId=' + labelId + '&ownerId=' + ownerId,{withCredentials: true}).then( () => {

            dispatch(msgCommentBar(['success', translate('textCommentSuccessfulDelete')]));


	        if (Object.keys(getState().profileReducer.setGmailAddOnData).length === 0) {
		        /*
                * GSC App
                * */
		        dispatch(findComments(contactId, 3));
	        } else {
		        /*
				* Gmail Add-On
				* */
		        dispatch(findComments(contactId, 50));
	        }

            /*
            * Refresh contacts list
            **/

            dispatch(findContacts(
                getState().contactsGroupItemReducer.getSelectedContactsGroup.id,
                getState().contactReducer.contactsPageSize,
                getState().contactReducer.contactsLetter
            ));

        }).catch(() => {
            dispatch(msgCommentBar(['error', translate('textCommentErrorDelete')]));
        }).finally(() => {
            dispatch(isLoadingCommentToAdd(false))
        });
    }
}

export function isLoadingCommentToAdd(boolean) {
    return function (dispatch) {
        dispatch({
            type: 'IS_LOADING_COMMENT_TO_ADD',
            payload: boolean
        })
    }
}

export function isLoadingCommentToEdit(boolean) {
    return function (dispatch) {
        dispatch({
            type: 'IS_LOADING_COMMENT_TO_EDIT',
            payload: boolean
        })
    }
}

export function isLoadingCommentToDelete(boolean) {
    return function (dispatch) {
        dispatch({
            type: 'IS_LOADING_COMMENT_TO_DELETE',
            payload: boolean
        })
    }
}

export function commentContentToAdd(string) {
    return function (dispatch) {
        dispatch({
            type: 'COMMENT_CONTENT_TO_ADD',
            payload: string
        })
    }
}

export function commentContentToEdit(string) {
    return function (dispatch) {
        dispatch({
            type: 'COMMENT_CONTENT_TO_EDIT',
            payload: string
        })
    }
}

export function parseContactOnCommentToAdd(array){
    return {
        type: "PARSE_CONTACT_ON_COMMENT_TO_ADD",
        payload: array
    }
}

export function parseContactOnCommentToEdit(array){
    return {
        type: "PARSE_CONTACT_ON_COMMENT_TO_EDIT",
        payload: array
    }
}

export function showUpgradeToBusinessToComment(boolean){
	return {
		type: "SHOW_UPGRADE_TO_BUSINESS_TO_COMMENT",
		payload: boolean
	}
}
